import { useField } from "react-final-form";
import { FormFieldProps } from "../builder";
import { FormControlLabel, FormControlLabelProps, FormHelperText, Switch, SwitchProps } from "@mui/material";
import useDisabled from "../hooks/useDisabled";
import useFieldName from "../hooks/useFieldName";

export interface FormSwitchFieldProps {
    label?: FormControlLabelProps["label"];
}

export default function FormSwitchField<FormValues>({
    f: _,
    field,
    label,
    disabled,
    ...props
}: FormFieldProps<FormValues, boolean | undefined> & SwitchProps & FormSwitchFieldProps) {
    field = useFieldName(field);
    disabled = useDisabled(disabled);
    const formField = useField(field, { type: "checkbox" });
    const isError = formField.meta.touched && Boolean(formField.meta.error || formField.meta.submitError);
    const switchControl = <Switch id={field} {...props} {...formField.input} disabled={disabled} />;
    const control = label ? (
        <FormControlLabel control={switchControl} label={label} disabled={disabled} />
    ) : (
        switchControl
    );
    return (
        <div>
            {control}
            <FormHelperText error={isError}>
                {isError && (formField.meta.error || formField.meta.submitError)}
            </FormHelperText>
        </div>
    );
}
